import React from "react";
import "./Works.css";
import Upwork from "../../img/Upwork.png";
import Fiverr from "../../img/fiverr.png";
import Shopify from "../../img/Shopify.png";
import Facebook from "../../img/Facebook.png";
import Amazon from "../../img/amazon.png";
import { motion } from "framer-motion";
import socializus from "../../img/SocialIzus.png";

function Works() {
  const transition = { duration: 3.5, type: "spring" };
  const reduceMotion =
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  return (
    <section className="works section">
      <div className="works-inner container">
        <div className="awesome">
          <div className="section-heading">
            <span>J’apprends très vite</span>
            <span className="accent">SocialIzus</span>
          </div>
          <p className="section-copy">
            J’ai appris les bases de React Native avec l’entreprise afin de
            participer au projet de développement de l’application de rencontre
            amicale sur Paris.
          </p>
          <img className="socializus" src={socializus} alt="SocialIzus" />
          <div className="blur s-blur1" style={{ background: "#ABF1FF94" }} />
        </div>

        <div className="w-right">
          <motion.div
            initial={reduceMotion ? false : { rotate: 45 }}
            whileInView={reduceMotion ? undefined : { rotate: 0 }}
            viewport={{ margin: "-40px" }}
            transition={transition}
            className="w-mainCircle"
          >
            <div className="w-secCircle">
              <img src={Upwork} alt="Upwork" />
            </div>
            <div className="w-secCircle">
              <img src={Fiverr} alt="Fiverr" />
            </div>
            <div className="w-secCircle">
              <img src={Amazon} alt="Amazon" />
            </div>
            <div className="w-secCircle">
              <img src={Shopify} alt="Shopify" />
            </div>
            <div className="w-secCircle">
              <img src={Facebook} alt="Facebook" />
            </div>
          </motion.div>

          <div className="w-backCircle blueCircle" />
          <div className="w-backCircle yellowCircle" />
        </div>
      </div>
    </section>
  );
}

export default Works;
